/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteFoodicsAccountsRequest
 */
export interface InviteFoodicsAccountsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteFoodicsAccountsRequest
     */
    ext_ids: Array<string>;
}

/**
 * Check if a given object implements the InviteFoodicsAccountsRequest interface.
 */
export function instanceOfInviteFoodicsAccountsRequest(value: object): value is InviteFoodicsAccountsRequest {
    if (!('ext_ids' in value) || value['ext_ids'] === undefined) return false;
    return true;
}

export function InviteFoodicsAccountsRequestFromJSON(json: any): InviteFoodicsAccountsRequest {
    return InviteFoodicsAccountsRequestFromJSONTyped(json, false);
}

export function InviteFoodicsAccountsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteFoodicsAccountsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ext_ids': json['ext_ids'],
    };
}

export function InviteFoodicsAccountsRequestToJSON(json: any): InviteFoodicsAccountsRequest {
    return InviteFoodicsAccountsRequestToJSONTyped(json, false);
}

export function InviteFoodicsAccountsRequestToJSONTyped(value?: InviteFoodicsAccountsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ext_ids': value['ext_ids'],
    };
}

